"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _TopBar = require("./TopBar");
Object.keys(_TopBar).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _TopBar[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _TopBar[key];
    }
  });
});